<template>
    <div class="h-100">
        <div class="filter-container">
            <div class="left-content">
                <b-dropdown ref="drop"
                            class="filter-dropdown"
                            variant="default">
                    <template #button-content>
                        <span class="lc"><i class="icon icon-filter"></i>{{ trMsg(MSG_BIP + 'filter.title') }}</span>
                        <span class="rc"><i class="icon icon-keyboard"></i></span>
                    </template>
                    <div>
                        <div class="top-content">
                            <span>{{ trMsg(MSG_FILTER + 'title') }}</span>
                            <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                        </div>
                        <!--------------- Плановый период ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'plan_period')">
                                <multiselect ref="bcPlanYear"
                                             v-model="planPeriod"
                                             track-by="name"
                                             label="name"
                                             :options="yearsFilter"
                                             :searchable="false"
                                             :allow-empty="false"
                                             :show-labels="false"
                                             @input="emitDatas">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Область/район ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'region_budget')">
                                <multiselect ref="bcRegionBudget"
                                             v-model="selRegionBudget"
                                             track-by="text"
                                             label="text"
                                             :options="regionBudgetList"
                                             :searchable="true"
                                             :allow-empty="false"
                                             :show-labels="false"
                                             @input="emitDatas">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Вид данных ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'data_type')">
                                <multiselect ref="bcDataType"
                                             v-model="selDataType"
                                             track-by="name"
                                             label="name"
                                             :options="dataTypeFilter"
                                             :searchable="true"
                                             :allow-empty="false"
                                             :show-labels="false"
                                             @input="changeFields">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Версия бюджета ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'version')">
                                <multiselect ref="bcVersion"
                                             v-model="selVersion"
                                             track-by="text"
                                             label="text"
                                             :options="versionFilter"
                                             :searchable="true"
                                             :allow-empty="false"
                                             :show-labels="false"
                                             @input="emitDatas">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- АБП ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'ABP')">
                                <multiselect ref="bcAbp"
                                             v-model="tmpAbp"
                                             track-by="abp"
                                             label="text"
                                             :options="dictTree || []"
                                             :placeholder="trMsg(MSG_FILTER + 'sel_abp')"
                                             :searchable="true"
                                             :allow-empty="true"
                                             :show-labels="false"
                                             @input="onAbpInput">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- БП ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'prg')">
                                <multiselect ref="bcPrg"
                                             v-model="tmpPrg"
                                             track-by="prg"
                                             label="text"
                                             :options="prgOptions"
                                             :disabled="!tmpAbp"
                                             :placeholder="trMsg(MSG_FILTER + 'all')"
                                             :close-on-select="false"
                                             :searchable="true"
                                             :multiple="true"
                                             :allow-empty="true"
                                             :show-labels="false"
                                             @input="onPrgInput">
                                    <template v-slot:selection="{ values, search, isOpen }">
                                        <template v-if="!isOpen">
                                            <template v-if="values.length > 1">
                                                    <span class="multiselect__single" id="multiselect__single">
                                                        {{ selCodes(tmpPrg, 'prg').join(', ') + '-' + trMsg(MSG_FILTER + 'prg') }}
                                                    </span>
                                            </template>
                                            <template v-else-if="values.length === 1 && values[0]">
                                                    <span class="multiselect__single">
                                                        {{ values[0].text }}
                                                    </span>
                                            </template>
                                        </template>
                                    </template>
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- БПП ------------------->
                        <div class="filter-block">
                            <b-form-group :label="trMsg(MSG_FILTER + 'ppr')">
                                <multiselect ref="bcPpr"
                                             v-model="tmpPpr"
                                             track-by="ppr"
                                             label="text"
                                             :options="pprOptions"
                                             :disabled="!tmpPrg || pprOptions.length === 0"
                                             :placeholder="trMsg(MSG_FILTER + 'all')"
                                             :close-on-select="false"
                                             :searchable="true"
                                             :multiple="true"
                                             :allow-empty="true"
                                             :show-labels="false"
                                             @input="onPprInput">
                                    <template v-slot:selection="{ values, search, isOpen }">
                                        <template v-if="!isOpen">
                                            <template v-if="values.length > 1">
                                                    <span class="multiselect__single" id="multiselect__single">
                                                        {{ selCodes(tmpPpr, 'ppr').join(', ') + '-' + trMsg(MSG_FILTER + 'ppr') }}
                                                    </span>
                                            </template>
                                            <template v-else-if="values.length === 1 && values[0]">
                                                    <span class="multiselect__single">
                                                        {{ values[0].text }}
                                                    </span>
                                            </template>
                                        </template>
                                    </template>
                                </multiselect>
                            </b-form-group>
                        </div>
                        <div class="filter-block">
                            <b-button variant="primary" @click="applyFilter">
                                {{ trMsg(MSG_BIP + 'btn.apply') }}
                            </b-button>
                        </div>
                    </div>
                </b-dropdown>
            </div>
            <div class="right-content">
                <div class="filter-actions" v-if="editing">
                    <b-button variant="success"
                              v-if="(selAbp !== null) && sign && sign.totalSign && sign.access && sign.ownerRegion && sign.present && (sign.status === 0) && (sign.abp_owner !== null)"
                              @click="logEDS('sign')">{{ trMsg(MSG_CDF + 'btn.sign_EDS') }}
                    </b-button>
                    <b-button variant="danger"
                              v-if="(selAbp !== null) && sign && (((sign.status > 0) && sign.ownerSign && sign.ownerRegion && sign.present && (sign.abp_owner !== null)) || sign.recall)"
                              @click="logEDS('revoke')">{{ trMsg(MSG_CDF + 'btn.revoke_EDS') }}
                    </b-button>
                    <b-button variant="warning"
                              :disabled="selAbp === null"
                              @click="logEDS('log')">{{ trMsg(MSG_CDF + 'btn.journal_EDS') }}
                    </b-button>
                    <b-button variant="success"
                              v-if="[3, 4].includes(selVersion.data_type)"
                              @click="openCorrect">
                        {{ trMsg(MSG_CDF + 'reasons') }}
                    </b-button>
                    <b-button variant="success"
                              v-if="!firstVariant"
                              @click="saveDatas">
                        {{ trMsg(MSG_BIP + 'btn.save') }}
                    </b-button>
                    <b-button variant="success"
                              v-if="[2, 3].includes(mode_level) && mode_opers !== null && mode_opers.includes('uebp_agree')"
                              @click="agreementEvent">
                        {{ trMsg(MSG_BIP + 'btn.actions') }}
                    </b-button>
                </div>
            </div>
        </div>
        <!--   хлебные крошки   -->
        <div class="filter-breadcrumb">
            <span v-if="!openFilterWindow && planPeriod"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcPlanYear')">
                {{ planPeriod.name }}
            </span>
            <span v-if="!openFilterWindow && selRegionBudget"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcRegionBudget')">
                {{ selRegionBudget.name }}
            </span>
            <span v-if="!openFilterWindow && selDataType"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcDataType')">
                {{ selDataType.name }}
            </span>
            <span v-if="!openFilterWindow && selVersion"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcVersion')">
                {{ selVersion.name }}
            </span>
            <span v-if="!openFilterWindow && selAbp !== null"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcAbp')">
                {{ selAbp.abp + '-' + trMsg(MSG_FILTER + 'ABP') }}
            </span>
            <span v-if="!openFilterWindow && selCodes(selPrg, 'prg').length"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcPrg')">
                {{ selCodes(selPrg, 'prg').join(', ') + '-' + trMsg(MSG_FILTER + 'prg') }}
            </span>
            <span v-if="!openFilterWindow && selCodes(selPpr, 'ppr').length"
                  class="item-breadcrumb"
                  @click="openFilterByRef('bcPpr')">
                {{ selCodes(selPpr, 'ppr').join(', ') + '-' + trMsg(MSG_FILTER + 'ppr') }}
            </span>
        </div>
        <!--   таблица   -->
        <div class="table-container">
            <b-table v-if="selVersion !== null"
                     :fields="tableFields"
                     :items="budgetForm"
                     :tbody-tr-class="rowClass"
                     :filter="filter.search"
                     :filter-included-fields="filter.on"
                     responsive="true"
                     bordered
                     head-variant="light"
                     sticky-header="true"
                     no-border-collapse>
                <template #thead-top="data">
                    <b-tr>
                        <b-th colspan="9"></b-th>
                        <b-th :colspan="add_need ? 3 : 2" class="text-center">
                            {{ planPeriod.year + ' ' + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() }}
                        </b-th>
                        <b-th colspan="2" class="text-center">
                            {{ parseInt(planPeriod.year) + 1 + ' ' + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() }}
                        </b-th>
                        <b-th colspan="2" class="text-center">
                            {{ parseInt(planPeriod.year) + 2 + ' ' + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() }}
                        </b-th>
                        <b-th colspan="4"></b-th>
                    </b-tr>
                </template>

                <template #head(check)="scope">
                    <b-form-checkbox v-model="check"
                                     v-if="selVersion && !selVersion.status && selVersion.attribute &&
                                           [2, 3].includes(mode_level) && mode_opers !== null && mode_opers.includes('uebp_agree')">
                    </b-form-checkbox>
                </template>
                <template #head(action)="scope">
                    <b-button @click="openAll()">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="open"></i>
                        <i class="icon icon-chevron-circle" v-if="!open"></i>
                    </b-button>
                </template>
                <template #head(abp)="scope">
                    <div>{{ trMsg(MSG_FILTER + 'ABP') }}</div>
                    <b-form-input
                        id="filter-input"
                        v-model="filter.abp"
                        type="search"
                        class="mini"
                    ></b-form-input>
                </template>
                <template #head(prg)="scope">
                    <div>{{ trMsg(MSG_FIELD + 'prg') }}</div>
                    <b-form-input
                        id="filter-input"
                        v-model="filter.prg"
                        type="search"
                        class="mini"
                    ></b-form-input>
                </template>
                <template #head(ppr)="scope">
                    <div>{{ trMsg(MSG_FIELD + 'ppr') }}</div>
                    <b-form-input
                        id="filter-input"
                        v-model="filter.ppr"
                        type="search"
                        class="mini"
                    ></b-form-input>
                </template>
                <template #head(spf)="scope">
                    <div>{{ trMsg(MSG_FIELD + 'spf') }}</div>
                    <b-form-input
                        id="filter-input"
                        v-model="filter.spf"
                        type="search"
                        class="mini"
                    ></b-form-input>
                </template>
                <template #head(name)="scope">
                    <div>{{ trMsg(MSG_FIELD + 'name') }}</div>
                    <b-form-input
                        id="filter-input"
                        v-model="filter.name"
                        type="search">
                    </b-form-input>
                </template>
                <template #head(receipt_prev)="scope">
                    <div>
                        {{ receiv_prev }}
                    </div>
                </template>
                <template #head(plan)="scope">
                    <div>
                        {{ plan }}
                    </div>
                </template>

                <template #cell(check)="data">
                    <template v-if="selVersion && selVersion.attribute
                    && [2, 3].includes(mode_level) && mode_opers !== null && mode_opers.includes('uebp_agree')
                    && [4, 5].includes(data.item.type) && !data.item['pprChild']
                    && data.item.status && [5, 36].includes(data.item.status.code)">
                        <b-form-checkbox v-model="data.item.check"
                                         :disabled="!newStatus(data.item) || data.item.closed"
                                         @change="test(data.item)">
                        </b-form-checkbox>
                    </template>
                </template>
                <template #cell(action)="data">
                    <b-button v-if="data.item.type === 3" @click="openChilds(data.item)" >
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open" ></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(abp)="data">
                    <div v-if="data.item.type === 3" class="text-right">
                        {{ data.value }}
                    </div>
                    <b-button v-if="data.item.type === 4 && data.item.hasChild"
                              @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(prg)="data">
                    <div v-if="data.item.type === 4" class="text-right">
                        {{ data.value }}
                    </div>
                    <b-button v-if="data.item.type === 5 && data.item.hasChild" @click="openChilds(data.item)">
                        <i class="icon icon-chevron-circle icon-rotate-180" v-if="data.item.open"></i>
                        <i class="icon icon-chevron-circle" v-if="!data.item.open"></i>
                    </b-button>
                </template>
                <template #cell(ppr)="data">
                    <div v-if="data.item.type === 5" class="text-right">
                        {{ data.value }}
                    </div>
                </template>
                <template #cell(spf)="data">
                    <div v-if="data.item.type === 6" class="text-right">
                        {{ data.value }}
                    </div>
                </template>
                <template #cell(name)="data">
                    <template v-if="data.item.id < 0 && [4, 5, 6].includes(data.item.type)">
                        <template v-if="data.item.id < 0 && data.item.type === 4">
                            <b-form-group :class="{ 'with-warning': existElem(data.item) }">
                                <multiselect v-model="data.item.code"
                                             track-by="text"
                                             label="text"
                                             :options="prgList"
                                             :searchable="true"
                                             :show-labels="false"
                                             @input="inputPrg(data.item)">
                                </multiselect>
                                <template v-if="existElem(data.item)">
                                    <div class="form-tooltip">
                                        <i class="icon icon-danger"></i>
                                        <div class="form-tooltip-content">
                                            <p class="red mb-2">
                                                {{ trMsg(MSG_SMS + 'attention') }} <br />
                                                {{ trMsg(MSG_CDF + 'prg_present_in_list') }}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </b-form-group>
                        </template>
                        <template v-if="data.item.id < 0 && data.item.type === 5">
                            <b-form-group :class="{ 'with-warning': existElem(data.item) }">
                                <multiselect v-model="data.item.code"
                                             track-by="text"
                                             label="text"
                                             :options="pprList"
                                             :searchable="true"
                                             :show-labels="false"
                                             @input="inputPpr(data.item)">
                                </multiselect>
                                <template v-if="existElem(data.item)">
                                    <div class="form-tooltip">
                                        <i class="icon icon-danger"></i>
                                        <div class="form-tooltip-content">
                                            <p class="red mb-2">
                                                {{ trMsg(MSG_SMS + 'attention') }} <br />
                                                {{ trMsg(MSG_CDF + 'prg_ppr_present_in_list') }}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </b-form-group>
                        </template>
                        <template v-if="data.item.id < 0 && data.item.type === 6">
                            <b-form-group :class="{ 'with-warning': existElem(data.item) }">
                                <multiselect v-model="data.item.code"
                                             track-by="text"
                                             label="text"
                                             :options="spfList"
                                             :searchable="true"
                                             :show-labels="false"
                                             @input="inputSpf(data.item)">
                                </multiselect>
                                <template v-if="existElem(data.item)">
                                    <div class="form-tooltip">
                                        <i class="icon icon-danger"></i>
                                        <div class="form-tooltip-content">
                                            <p class="red mb-2">
                                                {{ trMsg(MSG_SMS + 'attention') }} <br />
                                                {{ trMsg(MSG_CDF + 'prg_ppr_spf_present_in_list') }}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </b-form-group>
                        </template>
                    </template>
                    <div v-else>{{ data.item.name }}</div>
                </template>
                <template #cell()="data">
                    <div class="text-right">
                        {{ $n(doNum(data.value)) }}
                    </div>
                </template>
                <template #cell(request1)="data">
                    <template v-if="data.item.type === 6 && doNum(data.value) > 0">
                        <a href="#" @click="clkShowGu(data.item, 0)">
                            {{ $n(doNum(data.value)) }}</a>
                    </template>
                    <template v-else>{{ $n(doNum(data.value)) }}</template>
                </template>
                <template #cell(add_need)="data">
                    <template v-if="data.item.type === 6 && data.value !== 0">
                        <a href="#" @click="clkShowGuDelta(data.item, 0)">
                            {{ $n(doNum(data.value)) }}</a>
                    </template>
                    <template v-else>{{ $n(doNum(data.value)) }}</template>
                </template>
                <template #cell(request2)="data">
                    <template v-if="data.item.type === 6 && doNum(data.value) > 0">
                        <a href="#" @click="clkShowGu(data.item, 1)">
                            {{ $n(doNum(data.value)) }}</a>
                    </template>
                    <template v-else>{{ $n(doNum(data.value)) }}</template>
                </template>
                <template #cell(request3)="data">
                    <template v-if="data.item.type === 6 && doNum(data.value) > 0">
                        <a href="#" @click="clkShowGu(data.item, 2)">
                            {{ $n(doNum(data.value)) }}</a>
                    </template>
                    <template v-else>{{ $n(doNum(data.value)) }}</template>
                </template>
                <template #cell(plan1)="data">
                    <template v-if="editing && data.item.editable && !data.item.closed && data.item.type === 6">
                        <b-form-input class="text-right"
                                      :value="$n(data.item.plan1)"
                                      :disabled="!editing || firstVariant"
                                      @change="(v) => (data.item.plan1 = v)"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                      @blur="inputFixed( data.item, 'plan1', data.item.plan1, 1)">
                        </b-form-input>
                    </template>
                    <template v-else>
                        <div :class="{error: doNum(data.item.plan1) !== doNum(data.item.request1) }">
                            <div class="text-right">{{ $n(doNum(data.value)) }}</div>
                            <template v-if="doNum(data.item.plan1) !== doNum(data.item.request1)
                            && (data.item.type === 5 || (data.item.type === 4 && !data.item['pprChild']))">
                                <i class="icon icon-danger"></i>
                                <div class="pop-up">
                                    <p class="red-text">{{ trMsg(MSG_SMS + 'attention') }}</p>
                                    <p>{{ trMsg(MSG_CDF + 'discrepancy_ABP_version') }}</p>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
                <template #cell(plan2)="data">
                    <template v-if="editing && data.item.editable && !data.item.closed && data.item.type === 6 && selVersion.data_type < 4">
                        <b-form-input class="text-right"
                                      :value="$n(data.item.plan2)"
                                      :disabled="!editing || firstVariant"
                                      @change="(v) => (data.item.plan2 = v)"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                      @blur="inputFixed(data.item, 'plan2', data.item.plan2, 1)">
                        </b-form-input>
                    </template>
                    <template v-else>
                        <div :class="{error: doNum(data.item.plan2) !== doNum(data.item.request2)}">
                            <div class="text-right">{{ $n(doNum(data.value)) }}</div>
                            <template v-if=" doNum(data.item.plan2) !== doNum(data.item.request2) &&
                                    (data.item.type === 5 || (data.item.type === 4 && !data.item['pprChild']))">
                                <i class="icon icon-danger"></i>
                                <div class="pop-up">
                                    <p class="red-text">{{ trMsg(MSG_SMS + 'attention') }}</p>
                                    <p>{{ trMsg(MSG_CDF + 'discrepancy_ABP_version') }}</p>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
                <template #cell(plan3)="data">
                    <template v-if="editing && data.item.editable && !data.item.closed && data.item.type === 6 && selVersion.data_type < 4">
                        <b-form-input class="text-right"
                                      :value="$n(data.item.plan3)"
                                      :disabled="!editing || firstVariant"
                                      @change="(v) => (data.item.plan3 = v)"
                                      @keyup.enter.exact="keyup13"
                                      @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                      @blur="inputFixed(data.item, 'plan3', data.item.plan3, 1)">
                        </b-form-input>
                    </template>
                    <template v-else>
                        <div :class="{error: doNum(data.item.plan3) !== doNum(data.item.request3)}">
                            <div class="text-right">{{ $n(doNum(data.value)) }}</div>
                            <template v-if="doNum(data.item.plan3) !== doNum(data.item.request3) &&
                                    (data.item.type === 5 || (data.item.type === 4 && !data.item['pprChild']))">
                                <i class="icon icon-danger"></i>
                                <div class="pop-up">
                                    <p class="red-text">{{ trMsg(MSG_SMS + 'attention') }}</p>
                                    <p>{{ trMsg(MSG_CDF + 'discrepancy_ABP_version') }}</p>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
                <template #cell(status)="data">
                    <template v-if="[3].includes(data.item.type) && sign">
                        <div class="d-flex flex-column">
                            <a href="#" class="text-bold" :class="signStatusClass(sign.status)" @click="openSign">
                                УЭБП/ОЭБП: {{ signStatusText(sign.status) }}
                            </a>
                            <div class="border-bottom my-1"></div>
                            <a href="#" class="text-bold" :class="signStatusClass(sign.svod && sign.svod.status)" @click="openSign">
                                Свод по АБП: {{ signStatusText(sign.svod && sign.svod.status) }}
                            </a>
                        </div>
                    </template>
                    <template v-if="[4, 5].includes(data.item.type) && !data.item['pprChild']">
                        <div>
                            <template v-if="data.item.status">
                                {{ data.item.status.name }}
                            </template>
                            <template v-if="!data.item.status && newStatus(data.item)">
                                {{ trMsg(MSG_CDF + 'request_app') }}
                            </template>
                        </div>
                    </template>
                    <template v-if="[6].includes(data.item.type) && data.item.status && data.item.status.hasOwnProperty('agr_id')">
                        <div class="d-flex justify-content-center">
                            <template v-if="data.item.status.code">
                                <span class="rounded-status status-success"></span> <!-- соотвествует -->
                            </template>
                            <template v-else-if="!data.item.status.code">
                                <span class="rounded-status status-danger"></span> <!-- не соответствует -->
                            </template>
                        </div>
                    </template>
                </template>
                <template #cell(comments)="data">
                    <div v-if="[4, 5].includes(data.item.type) && !data.item['pprChild'] && data.item.status && data.item.status.comment.length > 0">
                        {{ data.item.status.comment }}
                    </div>
                    <!-- СПФ: заполненный комментарий - ссылка на модалку (вне статуса
                         "На рассмотрении УЭБП/ОЭБП" модалка открывается только на просмотр);
                         незаполненный - иконка, в режиме просмотра бледная и без клика -->
                    <div v-if="data.item.type === 6 && (!data.item.id || data.item.id > 0)">
                        <template v-if="spfComment(data.item)">
                            <a href="#"
                               v-if="spfAgreeAllowed"
                               @click.prevent="agreeSpfEvent(data.item)">
                                {{ spfComment(data.item) }}
                            </a>
                            <div v-else>
                                {{ spfComment(data.item) }}
                            </div>
                        </template>
                        <i v-else-if="spfAgreeAllowed && selVersion && selVersion.attribute"
                           class="icon"
                           :class="[spfIconClass(data.item), spfEditable(data.item) ? 'pointer' : 'icon-disabled']"
                           @click="spfEditable(data.item) && agreeSpfEvent(data.item)">
                        </i>
                    </div>
                </template>
                <template #cell(history)="data">
                    <b-dropdown dropleft class="more">
                        <template v-slot:button-content>
                            <i class="icon icon-more"></i>
                        </template>
                        <b-dropdown-item v-if="[4, 5].includes(data.item.type)
                                               && data.item.status && data.item.status.agr_id"
                                         @click="commentClk(data.item)">
                            {{ trMsg(MSG_CARD_SEC + '5.title') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="data.item.type === 6  && data.item.status && data.item.status.agr_id"
                                         @click="commentSpf(data.item)">
                            {{ trMsg(MSG_CARD_SEC + '5.title') }}
                        </b-dropdown-item>
                        <template v-if="editing">
                            <template v-if="data.item.type === 3 && !firstVariant && !data.item.closed">
                                <b-dropdown-item @click="addPrg(data.item)">
                                    {{ trMsg(MSG_CDF + 'add_prg') }}
                                </b-dropdown-item>
                            </template>
                            <template v-if="data.item.type === 4 && data.item['pprChild'] && !firstVariant && !data.item.closed">
                                <b-dropdown-item @click="addPpr(data.item)">
                                    {{ trMsg(MSG_CDF + 'add_ppr') }}
                                </b-dropdown-item>
                            </template>
                            <template v-if="!firstVariant && [4, 5].includes(data.item.type)
                                            && !data.item['pprChild'] && !data.item.closed
                                            && ((data.item.status && data.item.status.code !== 22)
                                            || !data.item.status)">
                                <b-dropdown-item v-if="[2, 3].includes(mode_level)"
                                                 @click="addSpf(data.item)">
                                    {{ trMsg(MSG_CDF + 'add_spf') }}
                                </b-dropdown-item>
                            </template>
                            <b-dropdown-item v-if="[4, 5].includes(data.item.type)
                                                   && ((data.item.status && data.item.status.code !== 22)
                                                   || !data.item.status)
                                                   && checkStatusPpr(data.item) === 0 && !firstVariant
                                                   && !data.item.closed"
                                             @click="deleteDatas(data.item)">
                                {{ trMsg(MSG_BIP + 'btn.delete') }}
                            </b-dropdown-item>
                            <b-dropdown-item v-if="[6].includes(data.item.type)
                                                   && checkStatusPpr(data.item) === 0
                                                   && !firstVariant && !data.item.closed"
                                             @click="deleteDatas(data.item)">
                                {{ trMsg(MSG_BIP + 'btn.delete') }}
                            </b-dropdown-item>
                        </template>
                    </b-dropdown>
                </template>
                <template #bottom-row="data">
                    <td class="text-right" colspan="7">
                        {{ trMsg(MSG_FIELD + 'total').toUpperCase() + ' (' + trMsg(MSG_CARD_SEC + '1.thousand_tg').toUpperCase() + ')' }}
                    </td>
                    <td class="text-right">{{ $n(total("receipt_prev")) }}</td>
                    <td class="text-right">{{ $n(total("plan")) }}</td>
                    <td class="text-right">{{ $n(total("request1")) }}</td>
                    <td class="text-right" v-if="add_need">{{ $n(total("add_need")) }}</td>
                    <td class="text-right">{{ $n(total("plan1")) }}</td>
                    <td class="text-right">{{ $n(total("request2")) }}</td>
                    <td class="text-right">{{ $n(total("plan2")) }}</td>
                    <td class="text-right">{{ $n(total("request3")) }}</td>
                    <td class="text-right">{{ $n(total("plan3")) }}</td>
                </template>
            </b-table>
            <loading :active="loading"
                     is-full-screen
                     spinner="bar-fade-scale"
                     color="#6495ED"/>
        </div>

        <c-budg-agr-modal ref="refAgrModal" :agrBtnLst="agrBtnLst" @agrClk="agrClick"></c-budg-agr-modal>
        <c-budg-agr-hist-modal ref="refHistModal"></c-budg-agr-hist-modal>
        <c-guelevel-modal ref="refGuLvlModal"></c-guelevel-modal>
        <c-budg-agr-spf-modal ref="refSpfModal" :spf="spf" @saveSpf="saveSpf"></c-budg-agr-spf-modal>
        <c-sign-log-modal ref="refSignLogModal" @updateSign="getCostDataSign"></c-sign-log-modal>
        <c-sign-status-modal ref="refSignStatusModal"></c-sign-status-modal>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueElementLoading from "vue-element-loading";
import CBudgetAgreementModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue";
import CBudgetAgreementHistModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-hist-modal.vue";
import CBudgetSumCalcGuLevelModal from "../budget-request/components/budget-sum-calc/budget-sum-calc-gulevel-modal";
import CBudgetAgreementSpfModal from "@/modules/budget/bip/budget-agreement-spf-modal.vue";
import CBudgetSignLogModal from "@/modules/budget/components/budget-sign-log-modal.vue";
import CBudgetSignStatusModal from "@/modules/budget/components/budget-sign-status-modal.vue";

import {
    makeToast,
    sortByField,
    getRowKey,
    filterVersion,
    versionByRegion,
    setCurVariant,
    postData,
    itemNameLocale,
    nameLocale,
    strFilter,
    getYearRanges,
    MSG_BIP,
    MSG_FILTER,
    MSG_SMS,
    MSG_CDF,
    MSG_FIELD,
    MSG_CARD_SEC,
    MSG_REQ_TH,
    trMsg,
    userUiid,
    DEFAULT_ARRAY, initLogging, showConfirmation, doNum, locale

} from "@/modules/budget/bip/bip-types";
import i18nService from "@/services/i18n";
import {numeric} from "vuelidate/lib/validators";

// код пункта "Все" в списках БП/БПП; строка, а не null - multiselect схлопывает null по track-by
const ALL_CODE = '__all__';
const NO_PPR_CODE = '000';

export default {
    name: "CostDataForm",

    components: {
        loading: VueElementLoading,
        "c-budg-agr-modal": CBudgetAgreementModal,
        "c-budg-agr-hist-modal": CBudgetAgreementHistModal,
        "c-guelevel-modal": CBudgetSumCalcGuLevelModal,
        "c-budg-agr-spf-modal": CBudgetAgreementSpfModal,
        "c-sign-log-modal": CBudgetSignLogModal,
        "c-sign-status-modal": CBudgetSignStatusModal
    },

    props: {
        location: { type: Object, default: () => {} },
        mode_level: { type: numeric, default: () => 0 },
        mode_opers: { type: Array, default: () => DEFAULT_ARRAY },
        regionBudgetList: { type: Array, default: () => DEFAULT_ARRAY },
        versionList: { type: Array, default: () => DEFAULT_ARRAY },
        dataTypeList: { type: Array, default: () => DEFAULT_ARRAY }
    },

    data() {
        return {
            MSG_BIP: MSG_BIP,
            MSG_FILTER: MSG_FILTER,
            MSG_SMS: MSG_SMS,
            MSG_CDF: MSG_CDF,
            MSG_FIELD: MSG_FIELD,
            MSG_CARD_SEC: MSG_CARD_SEC,

            mode_code: '004.003.003',
            mode: 'bp',

            openFilterWindow: false,
            open: false,
            check: false,
            loading: false,
            agree: false,
            add_need: false,

            meta: {},
            sign: undefined,

            yearsFilter: getYearRanges(),

            planPeriod: null,
            selRegionBudget: null,
            selDataType: null,
            selVersion: null,
            dictTree: null,

            // применённые значения фильтра (меняются только по кнопке "Применить")
            selAbp: null,
            selPrg: [],
            selPpr: [],

            // значения, которые пользователь крутит в дропдауне до нажатия "Применить"
            tmpAbp: null,
            tmpPrg: [],
            tmpPpr: [],

            budgetForm: [],
            pprMap: new Map(),
            valMap: new Map(),

            prgList: [], // список проограмм для выбора в ячейке таблицы
            pprList: [], // список подпрограмм для выбора в ячейке таблицы
            spfList: [], // список специфик для выбора в ячейке таблицы

            agrBtnLst: { back: [], forward: [] }, // доступные действия согласовании

            filter: {
                abp: null,
                prg: null,
                ppr: null,
                spf: null,
                name: null,
                search: null,
                on: ["filter", "abp", "prg", "ppr", "spf", "name"],
            },
            calcFlds: [
                "receipt_prev",
                "plan",
                "request1",
                "add_need",
                "plan1",
                "request2",
                "plan2",
                "request3",
                "plan3",
                "request1_1",
                "plan1_1",
                "request2_1",
                "plan2_1",
                "request3_1",
                "plan3_1",
                "request1_2",
                "plan1_2",
                "request2_2",
                "plan2_2",
                "request3_2",
                "plan3_2"
            ],
            idPrg: 0,
            idPpr: 0,
            idSpf: 0,
            spf: {}
        };
    },

    mounted() {
        initLogging('cdf mounted');

        this.initWatchers();
    },

    beforeUpdate() {
        this.budgetForm.forEach(row => {
            if ((row.type === 6 && !row.hasChild)) {
                // EAK-2000: специфики закрытого в ЕБК кода - только просмотр
                const editable = !(row.status && row.status.code === 22) && !row.closed;
                this.$set(row, "editable", editable);
            }
            else if ([0, 3, 4, 5].includes(row.type) && row.hasChild) {
                row._rowVariant = "info";
            }
        });
    },

    computed: {
        editing() {
            return ([2, 3].includes(this.mode_level) && this.selVersion && this.selVersion.attribute);
        },

        reading() {
            return ([2, 3].includes(this.mode_level) && this.selVersion);
        },

        dataTypeFilter() {
            return this.dataTypeList.filter((row) =>
                ["1", "2", "3", "4"].includes(row.code),
            );
        },

        versionFilter() {
            const result = filterVersion(this);
            for (const row of result) {
                if (row.date_start === null) {
                    this.$set(row, "ds", row.year + "-12-31");
                } else {
                    this.$set(row, "ds", row.date_start.toString());
                }
            }
            return result;
        }, // список для фильтра по версиям

        firstVariant() {
            if (this.selDataType && parseInt(this.selDataType.code) !== 1) {
                return false;
            }
            if (this.versionFilter) {
                let list = this.versionFilter.filter(
                    (row) => row.data_type === 1,
                );

                if (list.length > 0) {
                    list = list.sort(sortByField("ds"));
                    let first = list[0];
                    list = list.filter((row) => row['ds'] === first['ds']);
                    if (list.length > 1) {
                        list = list.sort(sortByField("id"));
                        first = list[0];
                    }
                    return this.selVersion.variant_uuid === first.variant_uuid;
                }
            }
            return false;
        },

        tableFields() {
            return [
                {
                    key: "check",
                    label: "",
                    class: "toggle-show"
                },
                {
                    key: "action",
                    label: "",
                    class: "toggle-show"
                },
                {
                    key: "abp",
                    label: trMsg(this, MSG_FILTER + 'ABP'),
                    class: "toggle-show"
                },
                {
                    key: "prg",
                    label: trMsg(this, MSG_FIELD + 'prg'),
                    class: "toggle-show"
                },
                {
                    key: "ppr",
                    label: trMsg(this, MSG_FIELD + 'ppr')
                },
                {
                    key: "spf",
                    label: trMsg(this, MSG_FIELD + 'spf')
                },
                {
                    key: "name",
                    label: trMsg(this, MSG_FIELD + 'name'),
                },
                {
                    key: "receipt_prev",
                    label: ""
                },
                {
                    key: "plan",
                    label: ""
                },
                {
                    key: "request1",
                    label: trMsg(this, MSG_BIP + 'report.BZ_ABP'),
                    variant: "info"
                },
                {
                    key: "add_need",
                    label: trMsg(this, MSG_REQ_TH + 'add_need'),
                    thClass: this.add_need ? '' : 'd-none',
                    tdClass: this.add_need ? '' : 'd-none'
                },
                {
                    key: "plan1",
                    label: trMsg(this, MSG_CDF + 'agreed_UEBP_OEBP')
                },
                {
                    key: "request2",
                    label: trMsg(this, MSG_BIP + 'report.BZ_ABP'),
                    variant: "info"
                },
                {
                    key: "plan2",
                    label: trMsg(this, MSG_CDF + 'agreed_UEBP_OEBP')
                },
                {
                    key: "request3",
                    label: trMsg(this, MSG_BIP + 'report.BZ_ABP'),
                    variant: "info"
                },
                {
                    key: "plan3",
                    label: trMsg(this, MSG_CDF + 'agreed_UEBP_OEBP')
                },
                {
                    key: "status",
                    label: trMsg(this, MSG_FILTER + 'status')
                },
                {
                    key: "comments",
                    label: trMsg(this, MSG_FIELD + 'comments')
                },
                {
                    key: "history",
                    label: ""
                },
                {
                    key: "filter",
                    label: "filter",
                    thClass: "d-none",
                    tdClass: "d-none"
                }
            ]
        },

        receiv_prev() {
            switch (`${i18nService.locale}`) {
                case 'ru':
                    return 'Исполнение за ' + (parseInt(this.planPeriod.year) - 2) + ' год'
                case 'kk':
                    return (parseInt(this.planPeriod.year) - 2) + ' жылғы атқарылуы'
                case 'en':
                    return 'Execution for ' + (parseInt(this.planPeriod.year) - 2) + ' year'
                default:
                    break;
            }
            return 'Исполнение за ' + (parseInt(this.planPeriod.year) - 2) + ' год';
        },

        plan() {
            switch (`${i18nService.locale}`) {
                case 'ru':
                    return 'Уточненный план на 1 апреля ' + (parseInt(this.planPeriod.year) - 1)
                case 'kk':
                    return (parseInt(this.planPeriod.year) - 1) + ' жылғы 1 сәуірге арналған нақтыланған жоспар'
                case 'en':
                    return 'Adjusted plan for April 1 ' + (parseInt(this.planPeriod.year) - 1)
                default:
                    break;
            }
            return 'Уточненный план на 1 апреля ' + (parseInt(this.planPeriod.year) - 1);
        },

        prgOptions() {
            if (!this.tmpAbp) return [];
            const list = (this.tmpAbp.value?.child ?? []).filter(prg => this.hasTreeData(prg));
            return [this.allItem('prg'), ...list];
        },

        // список БПП выбранных БП; пуст, если БП = "Все" или у выбранных БП нет подпрограмм (С9)
        pprOptions() {
            const prgs = (this.tmpPrg ?? []).filter(row => row.prg !== ALL_CODE);
            if (prgs.length === 0) return [];

            const byCode = new Map();
            for (const prg of prgs) {
                for (const ppr of (prg.value?.child ?? [])) {
                    // у БП без подпрограмм в child лежат сразу СПФ (type 6) - их пропускаем
                    if (ppr.value?.type !== 5) continue;
                    // проверка данных идёт до дедупликации: если один и тот же код пустой
                    // в одной БП и заполнен в другой, в списке останется заполненный
                    if (!this.hasTreeData(ppr)) continue;
                    if (!byCode.has(ppr.ppr)) {
                        byCode.set(ppr.ppr, ppr);
                    }
                }
            }

            if (byCode.size === 0) return [];

            // если среди выбранных БП есть программы без подпрограмм, даём их отдельным
            // пунктом - иначе их нельзя отличить от программ с БПП при выборе подпрограмм
            const flat = prgs.some(prg => !prg.value?.pprChild);
            return flat
                ? [this.allItem('ppr'), this.noPprItem(), ...byCode.values()]
                : [this.allItem('ppr'), ...byCode.values()];
        }
    },

    methods: {
        test(item) {
            // console.log('item', item)
        },

        // элемент "Все" для списков БП/БПП
        allItem(field) {
            return { [field]: ALL_CODE, text: trMsg(this, MSG_FILTER + 'all') };
        },

        // С16: значения фильтра применяются только по кнопке "Применить"
        async applyFilter() {
            const nextAbp = this.tmpAbp?.value ?? null;
            const abpChanged = (this.selAbp?.abp ?? null) !== (nextAbp?.abp ?? null);

            this.selAbp = nextAbp;
            this.selPrg = this.tmpPrg ?? [];
            this.selPpr = this.tmpPpr ?? [];

            if (nextAbp === null) {
                // С14: АБП не выбран - экран очищается, отчёты уходят по всем привязанным АБП
                this.budgetForm = [];
                this.pprMap.clear();
                this.sign = undefined;
                this.emitDatas();
            } else if (abpChanged) {
                await this.addAbp();
            } else {
                this.changeFields();
            }
            this.$refs.drop.hide(true);

            this.applyTreeFilter();
            this.deleteNulls();
        },

        // С14: скрывает ветки, не попадающие в выбранные БП/БПП
        applyTreeFilter() {
            const toSet = (list, field) => {
                const codes = this.selCodes(list, field);
                return codes.length > 0 ? new Set(codes) : null; // null означает "Все"
            };
            const prgSet = toSet(this.selPrg, 'prg');
            const pprSet = toSet(this.selPpr, 'ppr');

            if (prgSet === null && pprSet === null) return;

            // Коды сравниваем только на строках БП и БПП: они приходят из cost_tree_dev0,
            // где prg/ppr выровнены до 3 знаков. У строк СПФ те же поля приходят из других
            // источников (get_request_total) без выравнивания - '001' против 1, поэтому
            // потомков скрываем по родителю, а не по коду. Плюс у строк СПФ нет поля id
            // (агрегирующие выборки), так что родство отслеживаем по самим объектам.
            const rowById = this.rowsById();

            // 1. отбор по кодам на уровнях БП и БПП
            const matched = new Map();
            for (const row of this.budgetForm) {
                if (row.type === 4) {
                    // prg === null у только что добавленной строки - её не прячем
                    matched.set(row, prgSet === null || row.prg === null || prgSet.has(row.prg));
                } else if (row.type === 5) {
                    matched.set(row, (prgSet === null || row.prg === null || prgSet.has(row.prg))
                        && (pprSet === null || row.ppr === null || pprSet.has(row.ppr)));
                }
            }

            // 2. при выборе конкретных БПП программа остаётся, только если в ней есть
            // выбранная подпрограмма; для БП без подпрограмм её роль играет пункт "000"
            if (pprSet !== null) {
                const withMatchedPpr = new Set();
                for (const row of this.budgetForm) {
                    if (row.type === 5 && matched.get(row) && !this.isEmptyRow(row)) {
                        const parent = rowById.get(row.parent_id);
                        if (parent !== undefined) withMatchedPpr.add(parent);
                    }
                }
                for (const [row, ok] of matched) {
                    if (row.type !== 4 || !ok) continue;
                    matched.set(row, row.pprChild
                        ? withMatchedPpr.has(row)
                        : pprSet.has(NO_PPR_CODE));
                }
            }

            // 3. скрываем не прошедшие отбор и всё, что под ними
            const hidden = new Set();
            for (const row of this.budgetForm) {
                const parent = rowById.get(row.parent_id);
                const ok = matched.has(row) ? matched.get(row) : true;
                if (!ok || (parent !== undefined && hidden.has(parent))) {
                    hidden.add(row);
                    this.$set(row, 'visible', false);
                }
            }
        },

        async addAbp() {
            await this.prepareForm();
            await this.rememberDatas();
            await this.changeFields();
            await this.getCostDataSign();
            this.emitDatas();
        },

        addPrg(data) {
            const item = {
                id: --this.idPrg,
                parent_id: data.id,
                gr: data.gr,
                pgr: data.pgr,
                abp: data.abp,
                prg: null,
                ppr: null,
                spf: null,
                code: null,
                type: 4,
                visible: true,
                edited: false,
                open: true,
            };
            this.updateIndex(data, item);

            for (const abp of this.dictTree) {
                if (abp.abp === item.abp) {
                    // EAK-2000: закрытые в ЕБК коды выбирать нельзя
                    this.prgList = abp.value.child.filter(prg => !prg.value.closed);
                }
            }
        },

        addPpr(data) {
            const item = {
                id: --this.idPpr,
                parent_id: data.id,
                gr: data.gr,
                pgr: data.pgr,
                abp: data.abp,
                prg: data.prg,
                ppr: null,
                spf: null,
                code: null,
                type: 5,
                visible: true,
                edited: false,
                open: true,
            };
            this.updateIndex(data, item);

            for (const abp of this.dictTree) {
                if (abp.abp === item.abp) {
                    const prgList = abp.value.child;
                    for (const prg of prgList) {
                        if (prg.prg === item.prg) {
                            this.pprList = prg.value.child.filter(ppr => !ppr.value.closed);
                        }
                    }
                }
            }
        },

        addSpf(data) {
            const item = {
                id: --this.idSpf,
                parent_id: data.id,
                gr: data.gr,
                pgr: data.pgr,
                abp: data.abp,
                prg: data.prg,
                ppr: data.ppr,
                spf: null,
                code: null,
                type: 6,
                visible: true,
                edited: false,
            };
            this.updateIndex(data, item);
        },

        async agrClick(data) {
            await this.saveDatas();

            // Подготовка базовых данных
            const requestData = {
                lg: locale,
                userId: userUiid,
                variant: this.selVersion.variant_uuid,
                region: this.selRegionBudget.code,
                data_type: this.selDataType.code,
                abp: this.selAbp.abp,
                ...data
            };

            const newAgree = this.selectArr.map(el => {
                const elem = { ...el, ...requestData };

                // Обработка связанных SPF элементов
                const spfAgree = this.budgetForm
                    .filter(row =>
                        row.type === 6 &&
                        // row.visible &&
                        row.status?.agr_id > 0 &&
                        getRowKey(row, ['abp', 'prg', 'ppr']) === getRowKey(elem, ['abp', 'prg', 'ppr'])
                    )
                    .map(spf => {
                        const updatedSpf = {
                            ...spf,
                            user_id: userUiid,
                            cur_year: this.selVersion.year,
                            region: this.selVersion.region_code,
                            data_type: this.selVersion.data_type,
                            variant: this.selVersion.variant_uuid,
                            status: { ...spf.status, hist: true }
                        };
                        this.$set(spf, 'status', updatedSpf.status); // Для реактивности Vue
                        return updatedSpf;
                    });

                return { ...elem, spfAgree };
            });

            if (newAgree.length === 0) return;

            try {
                const response = await postData('/api-py/set-agreement-cost-with-spf', newAgree);

                response.forEach(res => {
                    const isSuccess = res.result === "success";
                    makeToast(
                        this, isSuccess ? "success" : "danger",
                        trMsg(this, MSG_SMS + (isSuccess ? 'saving' : 'error_save')),
                        isSuccess ? trMsg(this, MSG_SMS + 'datas_saved') : res.errTxt
                    );
                });

                this.agree = true;

                await this.sendNotif({ ...requestData, newAgree });
            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_save'),
                    error.message || trMsg(this, MSG_SMS + 'request_failed'));
            } finally {
                await this.updateDatas();
            }
        },

        // кнопка действия
        async agreementEvent() {
            // Сброс состояний
            this.selectArr = [];
            this.agrBtnLst = { back: [], forward: [] };

            // Фильтрация и проверка выбранных строк
            const selectedRows = this.budgetForm.filter(row =>
                row.check && [4, 5].includes(row.type) && !row.pprChild && row.status && !row.closed
            );

            if (selectedRows.length === 0) {
                makeToast(this, "warning", trMsg(this, MSG_SMS + 'coordination'),
                    trMsg(this, MSG_CDF + 'no_selected_prg_ppr'));
                return;
            }

            // Проверка одинакового статуса у всех выбранных элементов
            const firstStatus = selectedRows[0].status.code;
            if (selectedRows.some(row => row.status.code !== firstStatus)) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'coordination'),
                    trMsg(this, MSG_CDF + 'sel_prg_ppr_same_status'));
                return;
            }

            // Формирование массива выбранных элементов
            this.selectArr = selectedRows.map(row => ({
                agr_id: row.status.agr_id,
                cur_year: this.planPeriod.year,
                data_type: this.selDataType,
                abp: row.abp,
                prg: row.prg,
                ppr: row.ppr
            }));

            // Запрос следующих шагов согласования
            const params = {
                modeCode: this.mode,
                operationCode: this.mode_opers,
                agrCode: firstStatus
            };

            let result;
            try {
                const response = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
                result = await response.json();

                if (!result.length) {
                    makeToast(this, "warning", trMsg(this, MSG_SMS + 'coordination'),
                        trMsg(this, MSG_SMS + 'no_approval_steps_available'));
                    return;
                }
            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_request'),
                     '/get-agreement-step-next-back ' + error.toString());
                return;
            }

            // Разделение шагов на "назад" и "вперед"
            result.forEach(el => {
                itemNameLocale(el);
                this.agrBtnLst[el.stepType === 1 ? 'back' : 'forward'].push(el);
            });

            this.$refs.refAgrModal.showEvent();
        },

        async agreeSpfEvent(data) {
            if (!data.hasOwnProperty('status')) {
                this.$set(data, 'status', {});
                this.$set(data.status, 'agr_id', null);
                this.$set(data.status, 'code', undefined);
                this.$set(data.status, 'comment_txt', '');
                this.$set(data.status, 'comment', '');
            }
            this.spf = Object.assign({}, data);

            // this.$refs.refSpfModal.showEvent();
            this.$refs.refSpfModal.showEvent(!this.spfEditable(data));
        },

        // вспомогательный метод: считает статус подписи по списку подписантов и логу
        buildSignGroup(rawSigners, rawLogMap) {
            const signers = rawSigners ? [...rawSigners] : [];
            const logMap = new Map(Object.entries(rawLogMap || {}));
            const present = signers.some(row => row.id_user === userUiid);

            let signedCount = 0;
            let ownerSign = false;
            signers.forEach(row => {
                const logs = logMap.get(row.id_user) || [];
                const validSigns = logs.filter(el => !el.deleted);
                row.log = logs;
                if (validSigns.length) {
                    signedCount++;
                    if (row.id_user === userUiid) {
                        ownerSign = true;
                    }
                }
            });

            const status = signers.length > 0
                ? (signedCount === signers.length ? 1 : signedCount > 0 ? 2 : 0)
                : 0;

            nameLocale(signers, 'code', 'sign_');
            nameLocale(signers);

            return {
                signers,
                status,
                ownerSign,
                present,
                recall: present && logMap.get(userUiid)?.some(row => !row.deleted)
            };
        },

        changeFields() {
            for (const row of this.budgetForm) {
                if ([3, 4, 5].includes(row.type)) {
                    row.visible = true;
                }
                if (!row.hasChild) {
                    [
                        "plan1",
                        "plan2",
                        "plan3",
                        "request1",
                        "request2",
                        "request3",
                    ].forEach((field) => {
                        const f = field + "_" + this.selDataType.code;
                        if (row.hasOwnProperty(f)) {
                            this.$set(row, field, parseFloat(row[f]));
                        } else {
                            this.$set(row, field, 0);
                        }
                    });
                }
            }

            this.applyTreeFilter();
            this.deleteNulls();
            this.emitDatas();
        },

        checkStatusPpr(item) {
            let status = 0;
            const list = this.budgetForm.filter(row => row.status && [22].includes(row.status.code));

            if (item.type === 4) {
                for (const row of list) {
                    if (item.id === row.parent_id) {
                        status++;
                    }
                }
            }

            if (item.type === 6) {
                for (const row of list) {
                    if (item.parent_id === row.id) {
                        status++;
                    }
                }
            }
            return status;
        },

        // отмечает все ветки
        checkAll() {
            for (const row of this.budgetForm) {
                row.check = this.check;
            }
        },

        // показать ГУ
        clkShowGu(obj, prog) {
            const param = {
                year: this.planPeriod.year + prog,
                variant: this.selVersion.variant_uuid,
                abp: this.selAbp.abp,
                curYear: this.planPeriod.year,
                dataType: this.selDataType.code,
                prg: obj.prg,
                ppr: obj.ppr,
                spf: obj.spf,
                add_need: false
            };
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGuLvlModal.showEvent(param);
        },

        // показать ГУ
        async clkShowGuDelta(obj, prog) {
            const prev = await this.getPrevVariant();

            const param = {
                year: this.planPeriod.year + prog,
                variant: this.selVersion.variant_uuid,
                prev_variant: prev && prev?.prev_bv ? prev.prev_bv?.variant_uuid: '',
                abp: this.selAbp.abp,
                curYear: this.planPeriod.year,
                dataType: this.selDataType.code,
                prg: obj.prg,
                ppr: obj.ppr,
                spf: obj.spf,
                add_need: true
            };
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refGuLvlModal.showEvent(param);
        },

        // сравнивает введенные данные с ранее сохраненные и формирует массив новых записей для сохранения в БД
        compareDatas() {
            const saveDatas = [];
            for (const row of this.pprMap.values()) {
                if (row.edited) {
                    const val = this.valMap.get(getRowKey(row, ["abp", "prg", "ppr", "spf"]));
                    // this.pprMap.set(getRowKey(row, ["abp", "prg", "ppr", "spf"]), row);

                    if (!val || JSON.stringify(row) !== val) {
                        for (let i=0; i<3; i++) {
                            saveDatas.push(
                                this.newCost(row,
                                    parseFloat(row['plan' + (i + 1)]),
                                    parseInt(this.planPeriod.year + i)));
                        }
                        if (row.id < 0) {
                            this.$set(row, "id", 0);
                        }
                    }
                }
            }
            return saveDatas;
        },

        commentClk(row) {
            if (row.status && row.status.agr_id > 0) {
                const agrObj = {
                    id: row.status.agr_id,
                    type: row.type,
                    status: row.status.code,
                    updateDate: row.status.update_date,
                    userId: row.status.user_id,
                    abp: row.abp,
                    prg: row.prg,
                    ppr: row.ppr,
                    status_lang: {}
                    // this.$set(agrObj.status_lang, 'name_ru', row.status.name_ru);
                    // this.$set(agrObj.status_lang, 'name_kk', row.status.name_kk);
                    // this.$set(agrObj.status_lang, 'name_en', row.status.name_en);
                }

                this.$refs.refHistModal.showEvent(Object.assign(row.status, agrObj));
            }
        },

        commentSpf(item) {
            const agrObj = {
                id: item.status.agr_id,
                status: item.status.code,
                type: 6
            }
            this.$refs.refHistModal.showEvent(Object.assign(agrObj, item.status));
        },

        // древовидную выборку преобразовывает в таблицу (для отображения)
        createTable(elem, parentId) {
            // создание таблицы на основе дерева
            const that = this;
            const item = Object.assign({}, elem);
            itemNameLocale(item);
            this.$set(item, 'filter', strFilter(item, ['abp', 'prg', 'ppr', 'name']));

            if (item.status) {
                itemNameLocale(item.status);
            }

            // установка id родителя
            that.$set(item, "parent_id", parentId);

            // флажок для кнопок "Действия"
            that.$set(item, "check", false);

            // установка индекса строки
            that.$set(item, "index", that.budgetForm.length);

            // добавление элемента в таблицу
            that.$set(that.budgetForm, that.budgetForm.length, item);

            // поиск родителя
            Object.defineProperty(item, "parent", {
                get: function () {
                    for (const row of that.budgetForm) {
                        if (item.parent_id === row.id) {
                            return row;
                        }
                    }
                    return null;
                }
            });

            // hasChild - признак наличия подветок
            if (item.hasOwnProperty("child") && item.child.length > 0) {
                that.$set(item, "hasChild", true);
            }

            if (!item.hasChild) {
                that.calcFlds.forEach((field) => {
                    that.$set(item, field, doNum(item[field]));
                });

                if ([4, 5, 6].includes(item.type)) {
                    that.pprMap.set(getRowKey(item, ["abp", "prg", "ppr", "spf"]), item);
                }
            }

            // открыть все ветки кроме уровня SPF
            if ([4, 5].includes(item.type) && !item['pprChild']) {
                that.$set(item, "open", false);
            } else {
                that.$set(item, "open", true);
            }

            // показать все ветки кроме уровня SPF
            if (item.type === 6) {
                that.$set(item, "visible", false);
                Object.defineProperty(item, "add_need", {
                    get: function () {
                        return doNum(item.request1) - doNum(item.prev1);
                    }
                });
            } else {
                that.$set(item, "visible", true);
            }

            if (item.hasChild){
                that.calcFlds.forEach((field) => {
                    Object.defineProperty(item, field, {
                        get: function () {
                            return that.reSum(item, field);
                        },
                        configurable: true,
                    });
                });

                for (const ch of item.child) {
                    if ([4, 5].includes(item.type)) {
                        this.$set(ch.value, "develop_type", item.develop_type);
                    }
                    that.createTable(ch.value, item.id);
                }
                delete item.child;
            }
        },

        async deleteDatas(item) {
            let sms = "";
            switch (item.type) {
                case 3:
                    switch (`${i18nService.locale}`) {
                        case 'ru':
                            sms = '"Согласовано УЭБП/ОЭБП" АБП=' + item.abp
                                + ", удаленные данные восстановлению не подлежат. Удалить данные?";
                            break;
                        case 'kk':
                            sms = '"ЭБЖБ келісілді" ББӘ=' + item.abp
                                + ', жойылған деректер қалпына келтірілмейді. Деректерді жою керек пе?'
                            break;
                        case 'en':
                            sms = '"Agreed by UEBP/OEBP" ABP=' + item.abp
                                + ', deleted data cannot be restored. Delete data?'
                            break;
                        default:
                            break;
                    }
                    break;
                case 4:
                    switch (`${i18nService.locale}`) {
                        case 'ru':
                            sms = '"Согласовано УЭБП/ОЭБП" АБП=' + item.abp + " БП=" + item.prg
                                + ", удаленные данные восстановлению не подлежат. Удалить данные?";
                            break;
                        case 'kk':
                            sms = '"ЭБЖБ келісілді" ББӘ=' + item.abp + " ББ=" + item.prg
                                + ', жойылған деректер қалпына келтірілмейді. Деректерді жою керек пе?'
                            break;
                        case 'en':
                            sms = '"Agreed by UEBP/OEBP" ABP=' + item.abp + " BP=" + item.prg
                                + ', deleted data cannot be restored. Delete data?'
                            break;
                        default:
                            break;
                    }
                    break;
                case 5:
                    switch (`${i18nService.locale}`) {
                        case 'ru':
                            sms = '"Согласовано УЭБП/ОЭБП" АБП=' + item.abp + " БП=" + item.prg + " БПП=" + item.ppr
                                + ", удаленные данные восстановлению не подлежат. Удалить данные?";
                            break;
                        case 'kk':
                            sms = '"ЭБЖБ келісілді" ББӘ=' + item.abp + " ББ=" + item.prg + " БКБ=" + item.ppr
                                + ', жойылған деректер қалпына келтірілмейді. Деректерді жою керек пе?'
                            break;
                        case 'en':
                            sms = '"Agreed by UEBP/OEBP" ABP=' + item.abp + " BP=" + item.prg + " BPP=" + item.ppr
                                + ', deleted data cannot be restored. Delete data?'
                            break;
                        default:
                            break;
                    }
                    break;
                case 6:
                    switch (`${i18nService.locale}`) {
                        case 'ru':
                            sms = '"Согласовано УЭБП/ОЭБП" АБП=' + item.abp + " БП=" + item.prg + " БПП=" + item.ppr + " СПФ=" + item.spf
                                + ", удаленные данные восстановлению не подлежат. Удалить данные?";
                            break;
                        case 'kk':
                            sms = '"ЭБЖБ келісілді" ББӘ=' + item.abp + " ББ=" + item.prg + " БКБ=" + item.ppr + " Ерекшелік=" + item.spf
                                + ', жойылған деректер қалпына келтірілмейді. Деректерді жою керек пе?'
                            break;
                        case 'en':
                            sms = '"Agreed by UEBP/OEBP" ABP=' + item.abp + " BP=" + item.prg + " BPP=" + item.ppr + " SPF=" + item.spf
                                + ', deleted data cannot be restored. Delete data?'
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }

            showConfirmation(this, sms,
                () => {
                    switch (item.type) {
                        case 3:
                            for (const row of this.budgetForm) {
                                if (row.editable && row.abp === item.abp) {
                                    ["plan1", "plan2", "plan3"].forEach(
                                        (field) => {
                                            this.$set(row, field, 0);
                                        },
                                    );
                                    this.$set(row, "edited", true);
                                }
                            }
                            break;
                        case 4:
                            for (const row of this.budgetForm) {
                                if (
                                    row.editable &&
                                    getRowKey(row, ["abp", "prg"]) ===
                                    getRowKey(item, ["abp", "prg"])
                                ) {
                                    ["plan1", "plan2", "plan3"].forEach(
                                        (field) => {
                                            this.$set(row, field, 0);
                                        },
                                    );
                                    this.$set(row, "edited", true);
                                }
                            }
                            break;
                        case 5:
                            for (const row of this.budgetForm) {
                                if (row.editable &&
                                    getRowKey(row, ["abp", "prg", "ppr"]) ===
                                    getRowKey(item, ["abp", "prg", "ppr"])
                                ) {
                                    ["plan1", "plan2", "plan3"].forEach(
                                        (field) => {
                                            this.$set(row, field, 0);
                                        },
                                    );
                                    this.$set(row, "edited", true);
                                }
                            }
                            break;
                        case 6:
                            ["plan1", "plan2", "plan3"].forEach((field) => {
                                this.$set(item, field, 0);
                            });
                            this.$set(item, "edited", true);
                            break;
                        default:
                            break;
                    }
                    this.saveDatas();
                },
                () => {},
                trMsg(this, MSG_SMS + 'error_save'));
        },

        deleteNulls() {
            for (const row of this.budgetForm) {
                if (this.isEmptyRow(row) && row.spf === null) {
                    row.visible = false;
                }
            }
        },

        doNum(value, fix = 1) {
            return doNum(value, fix);
        },

        emitDatas() {
            if (this.selVersion) {
                const data = {
                    version: this.selVersion,
                    abp: (this.selAbp === null ? 0 : this.selAbp.abp),
                    datas: this.selAbp,
                    pprMap: this.pprMap
                };
                this.$emit("curFilter", data);
            }
        },

        existElem(item) {
            let count = 0;

            for (const row of this.budgetForm) {
                ["abp", "prg", "ppr", "spf"].forEach((field) => {
                    if (row[field] === undefined || row[field] === "None") {
                        this.$set(row, field, null);
                    }
                });

                if (getRowKey(row, ["abp", "prg", "ppr", "spf"]) ===
                    getRowKey(item, ["abp", "prg", "ppr", "spf"])) {
                    if (item.spf) {
                        count++;
                        continue;
                    }

                    if (row.visible === true) {
                        count++;
                    }
                }
            }

            return count > 1;
        },

        // формирует строку поиска
        filterUpdate() {
            this.filter.search =
                this.isStr(this.filter.abp) +
                this.isStr(this.filter.prg) +
                this.isStr(this.filter.ppr) +
                this.isStr(this.filter.spf) +
                this.isStr(this.filter.name);
            if (this.filter.search.length === 0) {
                this.filter.search = null;
            }
        },

        async getCostDataSign() {
            if (!this.selAbp) return;

            const params = {
                variant: this.selVersion.variant_uuid,
                region: this.selVersion.region_code,
                abp: this.selAbp.abp,
                owner: this.meta.gu?.abp_owner === this.selAbp.abp.toString(),
                mode: this.mode,
                mode_code: this.mode_code
            };

            try {
                this.loading = true;
                const response = await fetch(`/api-py/get-cost-status-sign/${encodeURI(JSON.stringify(params))}`)
                    .then((res) => res.json());

                const uebp = this.buildSignGroup(response.signers, response.logMap);
                const svod = this.buildSignGroup(response.svod.signers, response.svod.logMap);

                const ownerRegion = response.gu && this.meta.gu
                    ? response.gu.some(row => row.id_region === this.meta.gu.id_region)
                    : false;

                this.sign = {
                    gu: response.gu,
                    totalSign: response.totalSign,
                    ownerSign: uebp.ownerSign,
                    status: uebp.status,
                    access: false,
                    abp_owner: this.meta.gu,
                    present: uebp.present,
                    ownerRegion,
                    recall: uebp.recall,
                    signers: uebp.signers,
                    logList: response.logList,
                    svod: {
                        status: svod.status,
                        ownerSign: svod.ownerSign,
                        present: svod.present,
                        recall: svod.recall,
                        signers: svod.signers,
                        logList: response.svod.logList
                    }
                };

            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_load'),
                    '/get-cost-status-ecp ' + error.toString());
            } finally {
                // Проверка статусов SPF
                const listStat = this.budgetForm
                    .filter(row => row.spfChild)
                    .map(item => item.status || (this.newStatus(item) ? {
                        code: 1,
                        name_ru: 'Заявка (Проект)',
                        name_kk: 'Өтінім (Жоба)',
                        name_en: 'Application (Project)',
                        operations: [],
                        comment: ''
                    } : null))
                    .filter(Boolean);

                const allSigned = listStat.length > 0 &&
                    listStat.every(row => row.operations.includes('ecp_sign_uebp'));

                this.sign.access = allSigned;
                initLogging('cdf sign', this.sign);

                // Автоматический отзыв при необходимости
                if (!this.sign.access && this.agree) {
                    const revokeParams = {
                        variant: this.selVersion.variant_uuid,
                        abp: this.selAbp.abp,
                        comment: null,
                        user_id: userUiid,
                        auto: true
                    };

                    const revokeResponse = await postData('/api-py/revoke-cost-data', revokeParams);
                    if (revokeResponse.result === 'success' && revokeResponse.res > 0) {
                        makeToast(this, 'success',
                            trMsg(this, MSG_CDF + 'revoke_sign'),
                            trMsg(this, MSG_CDF + 'sign_revoked'));
                        await this.getCostDataSign(); // Рефреш данных
                    }
                }

                this.agree = false;
                this.loading = false;
            }
        },

        async getPrevVariant() {
            try {
                const response = await fetch('/api-py/get-prev-variant/' + this.selVersion.variant_uuid)
                    .then(response => response.json());
                return response;
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_load') + ' /get-prev-variant',
                    error.toString());
            }
        },

        // Есть ли в ветке дерева хоть одна ненулевая сумма. Бэкенд суммы на БП/БПП не
        // агрегирует (cost_data_form), поэтому спускаемся до листьев. Набор полей тот же,
        // что в deleteNulls, с поправкой на выбранный вид данных - иначе список БП
        // разойдётся с тем, что показано в таблице.
        hasTreeData(node) {
            const fields = ['receipt_prev', 'plan'];
            const dataType = this.selDataType?.code;
            if (dataType !== undefined && dataType !== null) {
                for (const field of ['plan1', 'plan2', 'plan3', 'request1', 'request2', 'request3']) {
                    fields.push(field + '_' + dataType);
                }
            }

            const walk = (elem) => {
                const value = elem?.value;
                if (!value) return false;
                for (const field of fields) {
                    // сравниваем по модулю: нули и NaN отсеиваем, знак значения не важен
                    if (Math.abs(parseFloat(value[field]) || 0) > 0) return true;
                }
                return (value.child ?? []).some(walk);
            };
            return walk(node);
        },

        // Основная инициализация наблюдателей
        initWatchers() {
            this.setupFilterWatchers();

            const watchConfig = [
                {
                    prop: 'regionBudgetList',
                    callback: (value) => {
                        if (value?.length) {
                            initLogging('regionBudgetList', value);
                            this.selRegionBudget = value[0];
                            versionByRegion(this);
                        }
                    }
                },
                {
                    prop: 'planPeriod',
                    callback: (value) => {
                        if (value) {
                            initLogging('planPeriod', value);
                            setCurVariant(this);
                        }
                    }
                },
                {
                    prop: 'selRegionBudget',
                    callback: async (value) => {
                        if (value) {
                            initLogging('selRegionBudget', value);
                            setCurVariant(this);
                        }
                    }
                },
                {
                    prop: 'selDataType',
                    callback: (value) => {
                        if (value) {
                            initLogging('selDataType', value);
                            setCurVariant(this, true);
                        }
                    }
                },
                {
                    prop: 'selVersion',
                    callback: async (value) => {
                        if (!value || this.loading) return;

                        this.selAbp = null;
                        this.selPrg = [];
                        this.selPpr = [];
                        this.tmpAbp = null;
                        this.tmpPrg = [];
                        this.tmpPpr = [];
                        this.sign = undefined;

                        initLogging('selVersion', value);
                        this.loading = true;
                        try {
                            // строго последовательно: loadDictTree читает meta.userAbp
                            await this.loadMetaDatas();
                            await this.updateDatas();
                        } finally {
                            this.loading = false;
                        }
                    }
                },
                {
                    prop: 'tmpAbp',
                    callback: () => {
                        this.selPrg = [];
                        this.selPpr = [];
                        this.tmpPrg = null;
                        this.tmpPpr = null;
                    }
                },
                {
                    prop: 'tmpPrg',
                    callback: () => {
                        this.selPpr = [];
                        this.tmpPpr = null;
                    }
                }
            ];

            watchConfig.forEach(({prop, callback}) => {
                this.$watch(prop, callback);
            });

            this.$watch("check", this.checkAll);
        },

        // форматирует введенное значение до digit цифр после запятой
        inputFixed(item, field, value, digit) {
            this.$set(item, field, doNum(value, digit));
            this.$set(item, "edited", true);

            this.$set(item, field + '_' + this.selDataType.code, value);
            this.pprMap.set(getRowKey(item, ["abp", "prg", "ppr", "spf"]), item);
        },

        inputPrg(item) {
            for (const [key, value] of Object.entries(item.code.value)) {
                this.$set(item, key, value);
            }
            this.$set(item, "name_ru", item.code.name);

            if (!item.code.value['pprChild']) {
                this.$set(item, "edited", true);
                this.calcFlds.forEach((field) => {
                    this.$set(item, field, 0);
                });
            } else {
                this.$set(item, "edited", true);
            }

            if (this.existElem(item)) {
                makeToast(this, "danger", trMsg(this, MSG_CDF + 'adding_new_entry'),
                    trMsg(this, MSG_CDF + 'prg_present_in_list'));
                return;
            }
            this.pprMap.set(getRowKey(item, ["abp", "prg", "ppr", "spf"]), item);
        },

        inputPpr(item) {
            for (const [key, value] of Object.entries(item.code.value)) {
                this.$set(item, key, value);
            }
            this.$set(item, "name_ru", item.code.name);
            this.$set(item, "edited", true);
            this.calcFlds.forEach((field) => {
                this.$set(item, field, 0);
            });

            if (this.existElem(item)) {
                makeToast(this, "danger", trMsg(this, MSG_CDF + 'adding_new_entry'),
                    trMsg(this, MSG_CDF + 'prg_ppr_present_in_list'));
                return;
            }
            this.pprMap.set(getRowKey(item, ["abp", "prg", "ppr", "spf"]), item);
        },

        inputSpf(item) {
            this.$set(item, "spf", item.code.spf);
            this.$set(item, "name_ru", item.code.name_ru);
            this.$set(item, "edited", true);
            this.calcFlds.forEach((field) => {
                this.$set(item, field, 0);
            });

            if (this.existElem(item)) {
                makeToast(
                    this,
                    "danger", trMsg(this, MSG_CDF + 'adding_new_entry'),
                    trMsg(this, MSG_CDF + 'prg_ppr_spf_present_in_list'));
                return;
            }
            this.pprMap.set(getRowKey(item, ["abp", "prg", "ppr", "spf"]), item);
        },

        // строка без данных по полям таблицы
        isEmptyRow(row) {
            let sum = 0;
            ["receipt_prev", "plan", "plan1", "plan2", "plan3",
                "request1", "request2", "request3"].forEach((field) => {
                sum += parseFloat(row[field]);
            });
            return sum === 0;
        },

        isStr(value) {
            return value === null || value === "None" ? "" : value;
        },

        // вводит по заданному паттерну
        keyPress: function (event, pattern) {
            // const regex = new RegExp('^[0-9]+$');
            // const regex = new RegExp('^-?\\d*\\d{0,9}$');
            // const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            // const regex = new RegExp(pattern);
            // const key = String.fromCharCode(
            //     !event.charCode ? event.which : event.charCode,
            // );
            // if (!regex.test(key)) {
            //     event.preventDefault();
            //     return false;
            // }

            const key = event.key;
            const regex = new RegExp(pattern);

            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            return true;
        },

        // enter работает как tab
        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll("input"); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el),
            );
            // focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        },

        async loadDictTree() {
            const params = {
                variant_uuid: this.selVersion.variant_uuid,
                user: userUiid
            };
            try {
                const response = await fetch(`/api-py/cost-data-form/${encodeURI(JSON.stringify(params))}`)
                    .then((response) => response.json());

                this.loading = true;
                this.add_need = response['add_need'];
                this.dictTree = [];
                // у пользователя без привязок в user_abp_link userAbp приходит null (п. 9.4)
                const userAbp = this.meta.userAbp ?? [];
                for (const row of response['dict_tree']) {
                    if (userAbp.includes(row.abp)) {
                        this.dictTree.push(row);
                    }
                }
            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'error_request') + ' /cost-data-form');
            } finally {
                for (const abp of this.dictTree) {
                    itemNameLocale(abp, 'abp');
                    itemNameLocale(abp.value, 'abp');
                    for (const prg of abp.value.child) {
                        itemNameLocale(prg, 'prg');
                        itemNameLocale(prg.value, 'prg');
                        for (const ppr of prg.value.child) {
                            itemNameLocale(ppr, 'ppr');
                            itemNameLocale(ppr.value, 'ppr');
                        }
                    }
                }
                initLogging('cdf dictTree', this.dictTree)
                await this.loadSpfList();
                this.pprMap.clear();
            }
        },

        async loadMetaDatas() {
            try {
                this.meta = await fetch('/api-py/get-user-meta/' + userUiid + '/' + this.selRegionBudget.code)
                    .then((response) => response.json());
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request') + ' /get-user-meta',
                    error.toString());
            } finally {
                initLogging('cdf userMeta', this.meta);
            }
        },

        async loadSpfList() {
            try {
                const result = await fetch(`/api-py/pkg-dict/ebk_ek/spf/` + this.selVersion.variant_uuid)
                    .then((response) => response.json());
                this.spfList = result['list'];
            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_load'),
                    ' /pkg-dict/ebk_ek/spf/' + error.toString());
            } finally {
                nameLocale(this.spfList, 'spf');
                initLogging('cdf spfList', this.spfList);
            }
        },

        /**
         * открыть Журнал
         */
        logEDS(mode) {
            // eslint-disable-next-line
            // @ts-ignore
            const params = {
                mode: this.mode,
                mode_sign: mode,
                version: this.selVersion,
                abp: this.selAbp,
                userGuList: this.meta['userGu'],
                userUiid: userUiid,
                plan1: this.budgetForm[0].plan1,
                plan2: this.budgetForm[0].plan2,
                plan3: this.budgetForm[0].plan3
            };
            Object.assign(this.sign, params);
            this.$refs.refSignLogModal.showEvent(this.sign, params);
        },

        // формирует элемент для сохранение в БД
        newCost(row, value, year) {
            return {
                type: row.type,
                gr: row.gr ? row.gr : null,
                pgr: row.pgr ? row.pgr : null,
                abp: row.abp,
                prg: row.prg,
                ppr: row.ppr,
                spf: row.spf,
                value: value,
                year: year,
                data_type: this.selVersion.data_type,
                region: this.selVersion.region_code,
                variant: this.selVersion.variant_uuid,
                user_name: userUiid
            };
        },

        newStatus(row) {
            return (row.request1 + row.request2 + row.request3 > 0);
        },

        // пункт "000 - Без подпрограммы" (доп. требование от 2026-09-02):
        // это полноценный выбор, а не "подпрограмма не выбрана"
        noPprItem() {
            return {
                ppr: NO_PPR_CODE,
                text: NO_PPR_CODE + ' - ' + trMsg(this, MSG_FILTER + 'no_ppr')
            };
        },

        // С12, С13: смена АБП сбрасывает БП и БПП в "Все"
        onAbpInput() {
            this.tmpPrg = [this.allItem('prg')];
            this.tmpPpr = [this.allItem('ppr')];
        },

        onPrgInput(value) {
            this.tmpPrg = this.pickAll(value, 'prg');
            this.tmpPpr = [this.allItem('ppr')];
        },

        onPprInput(value) {
            this.tmpPpr = this.pickAll(value, 'ppr');
        },

        // открывает.закрывает все ветки
        openAll() {
            this.open = !this.open;

            for (const row of this.budgetForm) {
                row.visible = this.open;
                if ([3, 4, 5].includes(row.type)) {
                    row.open = this.open;
                }
                if ([3].includes(row.type)) {
                    row.visible = true;
                }
            }

            this.applyTreeFilter();
            this.deleteNulls();
        },

        // открывает/закрывает ветку до конечного элемента
        openChilds(parent, bool) {

            parent.open = bool !== undefined ? bool : !parent.open;

            for (const row of this.budgetForm) {
                if (parent.id === row.parent_id) {
                    if ([3, 4].includes(row.type) ||
                        (!parent.open && row.type === 5))
                    {
                        this.openChilds(row, parent.open);
                    }
                    row.visible = parent.open;
                }
            }

            this.applyTreeFilter();
            this.deleteNulls();
        },

        openCorrect() {
            let url_name = "";
            if (this.selVersion.data_type) {
                if (this.selVersion.data_type === 4) {
                    url_name = "correct";
                    window.open(
                        "/#/budget-" +
                        url_name +
                        "?tab=1&version=" +
                        this.selVersion.variant_uuid,
                        "_blank",
                    );
                } else if (this.selVersion.data_type === 3) {
                    url_name = "clarify";
                    window.open(
                        "/#/budget-" +
                        url_name +
                        "?tab=1&version=" +
                        this.selVersion.variant_uuid,
                        "_blank",
                    );
                }
            }
        },

        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            const refItem = this.$refs[refName];
            setTimeout(() => refItem.$el.focus(), 100);
        },

        openSign() {
            this.$refs.refSignStatusModal.showEvent([
                { title: 'УЭБП / ОЭБП', status: this.sign.status, signUserLst: this.sign.signers },
                { title: 'Свод по АБП', status: this.sign.svod.status, signUserLst: this.sign.svod ? this.sign.svod.signers : [] }
            ]);
        },

        // С6: "Все" и конкретные значения взаимоисключаемы
        // С7: снятие последнего конкретного значения возвращает поле к "Все"
        pickAll(value, field) {
            if (!value || value.length === 0) return [this.allItem(field)];
            const last = value[value.length - 1];
            if (last[field] === ALL_CODE) return [this.allItem(field)];
            return value.filter(row => row[field] !== ALL_CODE);
        },

        // подготовка отображения данных
        async prepareForm() {
            this.pprMap.clear();
            this.budgetForm.splice(0);

            await this.createTable(this.selAbp, 0);
        },

        // расставляет сохранненные данные по полям
        async rememberDatas() {
            this.valMap.clear();
            for (const ppr of this.pprMap.values()) {
                this.$set(ppr, "edited", false);
                this.valMap.set(getRowKey(ppr, ["abp", "prg", "ppr", "spf"]), JSON.stringify(ppr));
            }
        },

        // пересчет суммы
        reSum(parent, field) {
            let sum = 0;
            this.budgetForm.forEach((row) => {
                if (
                    row.parent_id === parent.id &&
                    [row.type - 1, row.type - 2].includes(parent.type)
                ) {
                    sum += parseFloat(row[field]);
                }
            });
            return doNum(sum, 2);
        },

        // индекс строк по id; строки без id (СПФ) в индекс не попадают
        rowsById() {
            const map = new Map();
            for (const row of this.budgetForm) {
                if (row.id !== undefined && row.id !== null) {
                    map.set(row.id, row);
                }
            }
            return map;
        },

        // задает класс 'is-hidden' заданной строке
        rowClass(item, type) {
            if (!item || type !== "row") {
                return;
            }
            if (!item.visible) {
                return "is-hidden";
            }
        },

        // вызывает сохранение записей
        async saveDatas() {
            const res = this.compareDatas();
            if (res.length === 0) return;
            await showConfirmation(this,
                trMsg(this, MSG_CDF + 'want_save_data'),
                () => { this.saveVariant(res); },
                () => {}, trMsg(this, MSG_SMS + 'error_save'));
        },

        async saveSpf(data) {
            data.user_id = userUiid;
            data.cur_year = this.selVersion.year;
            data.region = this.selVersion.region_code;
            data.data_type = this.selVersion.data_type;
            data.variant = this.selVersion.variant_uuid;
            this.$set(data.status, 'hist', false);

            postData('/api-py/set_brftas', data).then((response) => {

                if (response.result === 'success') {
                    makeToast(this, "success", trMsg(this, MSG_SMS + 'saving'),
                        trMsg(this, MSG_SMS + 'datas_saved'));

                    const spf = this.pprMap.get(getRowKey(response, ["abp", "prg", "ppr", "spf"]));
                    if (spf) {
                        this.$set(spf, 'status', response);
                        if (response.comment_txt.length > 35) {
                            this.$set(spf.status, 'comment', response.comment_txt.substring(0, 35) + '...');
                        } else {
                            this.$set(spf.status, 'comment', response.comment_txt);
                        }
                        this.pprMap.set(getRowKey(spf, ["abp", "prg", "ppr", "spf"]), spf);
                    }
                    for (const row of this.budgetForm) {
                        if (row.type === 6 && row.status && row.status.agr_id === response.agr_id) {
                            this.$set(row, 'status', response);
                            if (response.comment_txt.length > 35) {
                                this.$set(row.status, 'comment', response.comment_txt.substring(0, 35) + '...');
                            } else {
                                this.$set(row.status, 'comment', response.comment_txt);
                            }
                            this.pprMap.set(getRowKey(row, ["abp", "prg", "ppr", "spf"]), row);
                            break;
                        }
                    }
                } else {
                    makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_SMS + 'error_save') + '/set_brftas');
                }
            });
        },

        // сохранение записей в БД
        async saveVariant(values) {
            const items = [values[0]];
            for (const el of values) {
                if (el.ppr !== items.at(-1).ppr
                    || el.spf !== items.at(-1).spf) {
                    items.push(el);
                }
            }

            for (let i = 0; i < items.length; i++) {
                if (items[i].spf === null && items[i + 1]?.ppr === null) {
                    items[i].spf = items[i + 1].spf;
                    items.splice(i + 1, 1);
                }
            }

            for (const x of items) {
                const prg = this.budgetForm.find((y) => y.prg === x.prg);
                if (x.spf === null
                    || (x.ppr === null && prg['pprChild'] === true)) {

                    makeToast(this, "danger", trMsg(this, MSG_SMS + 'warning'),
                        trMsg(this, MSG_CDF + 'fill_prg_ppr_spf'));
                    return;
                }
            }

            const data = [];
            for (const el of items) {
                for (const x of values.filter(
                    (v) => v.spf === el.spf && v.ppr === el.ppr && v.type === 6)) {
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    data.push({ ...x, ppr: el.ppr });
                }
            }
            try {
                const response = await fetch("/api-py/save-cost-form/" + this.planPeriod.year,
                    {
                        method: "POST",
                        headers: {"Content-Type": "application/json;charset=utf-8"},
                        body: JSON.stringify(data)
                    }
                );
                const result = await response.json();

                if (response.status === 200 && result.result === "success") {
                    makeToast(this, "success", trMsg(this, MSG_SMS + 'message'),
                        trMsg(this, MSG_SMS + 'datas_saved'));
                    await this.updateDatas();
                }
            } catch {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'error_save') + ' /api-py/save-cost-form/');
            }
        },

        // конкретные коды выбранного значения; пустой массив означает "Все"
        selCodes(list, field) {
            return (list ?? []).filter(row => row[field] !== ALL_CODE).map(row => row[field]);
        },

        async sendNotif(params) {
            try {
                const response = await postData('/api-py/send-notif', params);

            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_save'),
                    error.message || ' /send-notif');
            }
        },

        // Общий метод для обработки фильтров
        setupFilterWatchers() {
            const filterKeys = ['abp', 'prg', 'ppr', 'spf', 'name'];
            filterKeys.forEach(key => this.$watch(`filter.${key}`, this.filterUpdate));
        },

        signStatusText(status) {
            if (status === 1) return trMsg(this, MSG_CDF + 'signed');
            if (status === 2) return trMsg(this, MSG_CDF + 'part_signed');
            return trMsg(this, MSG_CDF + 'not_signed');
        },

        signStatusClass(status) {
            if (status === 1) return 'text-success';
            if (status === 2) return 'text-warning';
            return 'text-danger';
        },

        // доступ к согласованию по СПФ (уровень пользователя и операция УЭБП/ОЭБП)
        spfAgreeAllowed() {
            return ([2, 3].includes(this.mode_level)
                && this.mode_opers !== null
                && this.mode_opers.includes('uebp_agree'));
        },

        // редактирование комментария и оценки по СПФ доступно, только пока родительская БП
        // (а при наличии подпрограммы - БПП) в статусе "На рассмотрении УЭБП/ОЭБП" (5);
        // в остальных статусах, в том числе когда согласование ещё не начиналось, - только просмотр
        spfEditable(item) {
            return (this.spfAgreeAllowed
                && this.selVersion && this.selVersion.attribute
                && !item.closed
                && item['parent_status'] && item['parent_status'].code === 5);
        },

        spfComment(item) {
            return ((item.status && item.status.comment) || '');
        },

        spfIconClass(item) {
            return (item.status && item.status.agr_id > 0
                ? 'icon-pencil-edit text-primary'
                : 'icon-plus-circle add-button');
        },

        // итого по заданному полю
        total(field) {
            let sum = 0;

            for (const row of this.budgetForm) {
                // скрытые фильтром БП/БПП строки в итог не попадают (С14)
                if (row.type === 4 && row.visible) {
                    sum += doNum(row[field]);
                }
            }
            return doNum(sum);
        },

        // translate messages
        trMsg(field) {
            return trMsg(this, field);
        },

        // расставляет сохраненные данные по полям
        async updateDatas() {
            this.loading = true;
            this.tmpAbp = null;
            this.selAbp = null;
            this.budgetForm = [];

            try {
                await this.loadDictTree();

                if (this.selAbp) {
                    await this.prepareForm();

                    // Используем find для поиска элемента вместо цикла
                    const foundItem = this.dictTree.find(item => item.abp === this.selAbp.abp);
                    if (foundItem) { this.selAbp = foundItem.value;
                        // после перезагрузки дерева переподвязываем поле фильтра на новый объект,
                        // но только при реальной смене кода - иначе собьём выбор БП/БПП
                        if (this.tmpAbp?.abp !== foundItem.abp) {
                            this.tmpAbp = foundItem;
                        }
                    }
                }
            } finally {
                this.loading = false;

                if (this.firstVariant) {
                    makeToast(this, "warning",
                        trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_CDF + 'first_forecast_ver_edit_limits_mode'));
                }

                // Параллельное выполнение асинхронных операций
                await Promise.all([
                    this.rememberDatas(),
                    this.changeFields(),
                    this.getCostDataSign()
                ]);
            }
        },

        updateIndex(data, item) {
            const that = this;
            this.$set(data, "edited", false);
            this.budgetForm.splice(data.index + 1, 0, item);
            this.calcFlds.forEach((field) => {
                this.$set(item, field, 0);
            });

            let ind = 0;
            for (const row of this.budgetForm) {
                this.$set(row, "index", ind++);
            }
            if (data.editable) {
                this.calcFlds.forEach((field) => {

                    Object.defineProperty(data, field, {
                        get: function () {
                            return that.reSum(data, field);
                        },
                        configurable: true,
                    });
                });
            }
            this.$set(data, "editable", false);
            this.$set(data, "hasChild", true);
        }
    }
};
</script>
